<div class="tipiWrapper" [ngClass]="canBack ? 'mp-0' : 'auto'" id="tipiWrapperID">
    <div class="tipovisita" id="tipovisita__{{idx}}" *ngFor="let tipovisita of tipivisiteFiltered; let idx = index"
        [ngClass]="canBack ? 'mp-0' : 'auto'">
        <div class="left__side__content">
            <div class="image__container">
                <div class="tipologie">
                    <app-tipologie [tipologie]="tipovisita.tipo"></app-tipologie>
                </div>
                <img src="{{tipovisita.imgsrc}}" alt="Immagine copertina visita {{tipovisita.nome}}"
                    title="Immagine copertina visita {{tipovisita.nome}}" class="image__img">
                <div class="instant__wrapper">
                    <div class="instant booking" *ngIf="tipovisita.totVisite > 0 && tipovisita.confermabile !== '1'">
                        {{'base.conferma_istantanea' | translate}}
                        <span class="material-symbols-outlined">
                            bolt
                        </span>
                    </div>
                    <div class="instant pcantina"
                        *ngIf="tipovisita.totVisite > 0 && tipovisita.pagacantina_visita === '1'">
                        {{'base.paga_sc' | translate}}
                        <span class="material-symbols-outlined">
                            credit_card
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="right__side__content">
            <app-dettaglio-tipovisita [tipovisita]="tipovisita" [codiceForm]="tipovisita.codiceForm"
                [codiceFormMaster]="codiceFormMaster" [linguaCorrente]="linguaCorrente"
                [canBack]="idx == idxSelezionato || base ? canBack : false" [idx]="idx" [cart]="cart"
                (goBack)="tornaIndietro()" (lastStepClicked)="lastStepClicked($event)"></app-dettaglio-tipovisita>
        </div>
    </div>
</div>